import { createFileRoute } from '@tanstack/react-router'
import TrustCenterNdaPage from '@/pages/trust-center/public/TrustCenterNdaPage'

export const Route = createFileRoute('/trust/nda/$token')({
  component: NdaRoute,
})

function NdaRoute() {
  const { token } = Route.useParams()
  return <TrustCenterNdaPage token={token} />
}
